import './index.css';
import React from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import * as Sentry from '@sentry/react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import store from './store/configure-store';

const root = ReactDOM.createRoot(document.getElementById('root'));
if (
  process.env.REACT_APP_SENTRY_ENABLED === 'true' &&
  process.env.REACT_APP_TRACKING_ENABLED === 'true'
) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [Sentry.browserTracingIntegration()],
    environment: process.env.REACT_APP_ENVIRONMENT,
    tracesSampleRate: parseFloat(process.env.REACT_APP_SENTRY_TRACE_SAMPLE_RATE) || 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    performanceMonitoring: true,
    ignoreErrors: [
      'ResizeObserver loop limit exceeded', // Chrome known issue
      'NetworkError when attempting to fetch resource.', // Common network error
    ],
  });
}

root.render(
  // <React.StrictMode>
  <ReduxProvider store={store}>
    <App />
  </ReduxProvider>,
  // </React.StrictMode>,
);

reportWebVitals();
